import React from 'react';

export function SQLYt() {
  // Array of playlist data
  const playlists = [
    { id: 1, name: "SQL College", link: "https://www.youtube.com/watch?v=ESnrn1kAD4E&ab_channel=ApnaCollege" },
    { id: 2, name: "SuperSimpleDev (Highly Recommended)", link: "https://www.youtube.com/watch?v=G3e-cpL7ofc&t=1062s&ab_channel=SuperSimpleDev" },
    { id: 3, name: "PW Skills Tech", link: "https://www.youtube.com/watch?v=WuiB5TAQOAM&ab_channel=PWSkillsTech" },
    { id: 4, name: "FreeCodeCamp", link: "https://www.youtube.com/watch?v=OXGznpKZ_sA&ab_channel=freeCodeCamp.org" },
    { id: 5, name: "Bro Code", link: "https://www.youtube.com/watch?v=HGTJBPNC-Gw&ab_channel=BroCode" },
    { id: 6, name: "FreeCodeCamp (CSS)", link: "https://www.youtube.com/watch?v=1Rs2ND1ryYc&ab_channel=freeCodeCamp.org" },
    { id: 7, name: "Thapa Technical (Recommended)", link: "https://www.youtube.com/watch?v=MSICFljRcb4&t=23300s&ab_channel=ThapaTechnical" },
    { id: 8, name: "Anuj Bhaiya (Tailwind CSS)", link: "https://www.youtube.com/watch?v=mGN9-FPsX9o&t=1043s&ab_channel=AnujBhaiya" },
    { id: 9, name: "Apna College (Recommended)", link: "https://www.youtube.com/watch?v=nGhKIC_7Mkk&ab_channel=ApnaCollege" },
    { id: 10, name: "WsCube Tech (Tailwind CSS)", link: "https://www.youtube.com/watch?v=Sae1MD5E5p8&ab_channel=WsCubeTech" },
  ];

  return (
    <div>
      {/* Heading */}
      <h1 className="html_yt_heading">
        These are the <strong style={{ textDecoration: "underline", color: "blue" }}>Top 10</strong> YouTube Playlists You Can Refer To
      </h1>

      {/* Description */}
      <h4 className="des_yt_html">
        1. Dive Into The Main Concepts <br />
        2. Animation Explanations with Real-World Examples <br />
        3. Important with Note Clarification
      </h4>

      {/* Playlist Links */}

      {playlists.map((playlist) => (

        <div key={playlist.id} className="container_html_yt_links">
          <p className="vid">
            {playlist.id}. {playlist.name}

            <button
              style={{
                marginLeft: "200px",
                padding: "7px",
                background: "black",
                color: "white",
                borderRadius: "8px",
              }}
              onClick={() => window.open(playlist.link, "_blank")}
            >
              Click Me
            </button>
          </p>
        </div>
      ))}
    </div>
  );
}

export default SQLYt;
